import {Button, Stack} from "@chakra-ui/react";
import {scrollToElement} from "@/utils/scrollToElement";
import {BUTTON_VARIANTS} from "@/theme/components/button";
import KeyFeaturesComponent from "@/components/keyFeatures";
import {WHY_ONEMIND_CONSTANTS} from "./constants";

const WhyOneMindComponent = () => {
  return (
    <Stack mb={6} w="100%">
      <KeyFeaturesComponent {...WHY_ONEMIND_CONSTANTS} CARD_HEIGHT="210px" />
      <Button
        variant={BUTTON_VARIANTS.IDEAL}
        onClick={() => scrollToElement("contact-us", 120)}
        mt={3}
        alignSelf={"center"}
        p={6}
      >
        Ready To Try?
      </Button>
    </Stack>
  );
};

export default WhyOneMindComponent;
